
fx.ns("shared.popups", class EnterPhoneNumber extends fx.components.Popup{
    
    constructor(data)
    {
        super(data);

        this.contentWidth = 600;
        this.contentHeight = 450;

        this.timeout = 20000; // 20s timeout for qrcode tries
    }

    create()
    {
        super.create();
 
        this.hbox_phone = new fx.components.HBox();
        this.hbox_qrcode = new fx.components.HBox();
        this.hbox_phoneinput = new fx.components.HBox();

        this.flagSelect = new fx.components.CountrySelect();
        this.hbox_phone.addChild(new shared.component.Person(fx.get("assets").personAdvice), {width:200, height : 200, left : "center"});
        this.hbox_phone.addChild(new fx.components.Text({text:fx.text("Comment faire ?"), className:"title center"}), {height:30, left:0, width:"100%"});
        this.hbox_phone.addChild(new fx.components.Text({text:fx.text("Entrez votre numéro de téléphone portable. Vous recevrez un sms avec le lien de l'application. Vous pourrez alors envoyer vos photos vers votre albums.", (fx.browser.isMac ? "COMMAND" : "CTRL")), className:"text center"}), {left:0, width:"100%"});
        this.phone = new fx.components.Input({placeHolder:fx.text("Téléphone"), name:"phone", id:"phone", type:"tel", value: "", pattern:"[0-9]*", className: "phone"});
        this.hbox_phoneinput.addChild(this.flagSelect, {width:95, height:35, top: 7, left: 35});
        this.hbox_phoneinput.addChild(this.phone, {width:"280px", right: 10});
        this.hbox_phone.addChild(this.hbox_phoneinput);
        // error label
        this.errorText = new fx.components.Text({text:fx.text("numéro invalide", (fx.browser.isMac ? "COMMAND" : "CTRL")), className:"errortext text center"});
        this.hbox_phone.addChild(this.errorText, {left:0, width:"100%"});
        // button   
        this.okButton = new fx.components.Button({label : fx.text("C'est parti !"), type : "filled"});
        this.hbox_phone.addChild(this.okButton, {bottom:20, height:60, width : 200, left:"center"});
        
        this.qrcode = new fx.components.Image({className : "qrcode"});
        this.hbox_qrcode.addChild(this.qrcode, {left:0, width:"100%"});
        this.hbox_qrcode.addChild(new fx.components.Text({text:fx.text("plus rapide"), className:"importantext qrcode-infotext text center"}), {left:"center"});
        this.hbox_qrcode.addChild(new fx.components.Text({text:fx.text("Scannez ce QRcode pour récupérer les photos depuis votre mobile"), className:"importantext text center"}), {left:0, width:"100%"});

        this.addChild(this.hbox_phone, {top: -100, width: "65%", left: 0});
        this.addChild(this.hbox_qrcode, {top: 20, width: "35%", right: 0});
    }

    onReady()
    {
        super.onReady();
        this.errorText.hide();

        fx.service("SmsService").start();

        this.on("click", this._onFlagSelectorClick, this.flagSelect);
        this.on("click", this.send, this.okButton);
        this.phone.node.addEventListener("keypress", function(event){   // cause this.on("click") doesn't work on inputs
          if(event.key === "Enter"){
            this.send();
          }
        }.bind(this));
        this.on("ESCAPE", this.close, fx.keyboard);
        this.repeat(this._updateQrcode, 250);
    }

    _updateQrcode(){
      this.timeout-=250;
      let qrCode;
      if(fx.service("SmsService").qrCode)
        qrCode = fx.service("SmsService").qrCode;
      let id = Utils.newID();
      let asset = new fx.Asset(qrCode, id);
      if(qrCode)
      {
        this.qrcode.data = asset;
        this.repeat(this._updateQrcode, null);
      }
      if(this.timeout<0)
        this.repeat(this._updateQrcode, null);
    }

    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    isValidNumber(phoneNumber){
      var regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
      if(phoneNumber.toString().match(regex))
        return true;
      return false;
    }

    isValidDialcode(dialcode){
      var regex = /^\+[0-9]*$/;
      if(dialcode.toString().match(regex))
        return true;
      return false;
    }

    send()
    {
        let phoneNumber = fx.dom.find("input[type='tel']").value;

        if(phoneNumber)
        {
            if(this.isValidNumber(phoneNumber))
            {
                this.errorText.hide();
                let dialcode = fx.dom.find(".flag").getAttribute("dialcode");
                dialcode = this.isValidDialcode(dialcode) ? dialcode : "";
                fx.service("SmsService").send(phoneNumber.toString(), dialcode);

                this.close();
                this.data.event("mobile-upload-send");
            } 
            else 
            {
                this.errorText.show();
            }
        }
    }


});